import { render, staticRenderFns } from "./AffiliateReportFields.vue?vue&type=template&id=853c0862"
import script from "./AffiliateReportFields.vue?vue&type=script&lang=js"
export * from "./AffiliateReportFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports